import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars

export const ParamTable = ({id, content}) => {
    return (
        <div className="responsive-table" id={ id }>
            <h3 className="table-title">PARAMETERS</h3>
            <table className="endpoint-params" cellSpacing="0" cellPadding="0">
                <thead>
                    <tr>
                        <th className="col">NAME</th>
                        <th className="col">TYPE</th>
                        <th className="col">DEFAULT VALUE</th>
                        <th className="col-description wide">DESCRIPTION</th>
                    </tr>
                </thead>
                {content.map( (row) => {
                    return (
                        <tbody className='table-row'>
                            <tr>
                                <td>
                                    <div className="table-bold-text">{row.name}</div>
                                    <div className="table-gray-text">{row.status}</div>
                                </td>
                                <td>
                                    {row.type}
                                </td>
                                <td>
                                    {row.default ? row.default : 'n/a'}
                                </td>
                                <td className="col-description wide">
                                    {Array.isArray(row.description) ?
                                        row.description.map((paragraph) => {
                                            return <p> {paragraph} </p>;
                                        }) :
                                        row.description
                                    }
                                </td>
                            </tr>
                            <tr className="col-description narrow">
                                <td colSpan={3}>
                                    <div className="mobile-heading">DESCRIPTION</div>
                                    {Array.isArray(row.description) ?
                                        row.description.map((paragraph) => {
                                            return <p> {paragraph} </p>;
                                        }) :
                                        row.description
                                    }
                                </td>
                            </tr>
                        </tbody>
                    );
                })}
            </table>
        </div>
    );
};
